module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-sm-10\"> <p>Webhooks are used to send your server notifications about what is happening with your data on EasyPost. For instance, when a shipment has its tracking status updated from <strong>out_for_delivery</strong> to <strong>return_to_sender</strong> we can notify your server so you can reach out to your customer and let them know what happened. Check out <a href=\"/webhooks-guide\">Webhooks Guide</a> for more details and best practices.</p> </div> </div> <div class=\"row\"> <div id=\"prod_webhook_list\" class=\"col-sm-6 section-margin-bottom\"></div> <div id=\"test_webhook_list\" class=\"col-sm-6 section-margin-bottom\"></div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/webhooks_page.ejs
// module id = 887
// module chunks = 1